module.exports = __webpack_public_path__ + "media/images/svg/heart-5f3974c22c9956ac7c8bb41851aa1c18.svg";